import { convertToAcronym } from '../../../utils';

/**
 * Generates the description text for EHR integration benefits.
 * @param ehrDisplayName - The display name of the EHR system
 * @returns The formatted description text
 */
export const getEhrIntegrationDescription = (ehrDisplayName: string): string => {
  const displayName = ehrDisplayName || 'EHRs';
  return `Tandem can connect with ${displayName} to securely pull visit notes, lab results, insurance cards, and pharmacy details—saving your team time and helping patients start therapy faster.`;
};

/**
 * Generates the EHR integration email address for a practice.
 * @param practiceName - The name of the practice
 * @returns The formatted email address (e.g., "ehr+PracticeName@withtandem.com")
 */
export const generateEhrEmail = (practiceName: string): string => {
  const sanitizedPracticeName = practiceName.replace(/[^a-zA-Z0-9]/g, '');
  return `ehr+${sanitizedPracticeName}@withtandem.com`;
};

/**
 * Generates the last name for EHR integration credentials using the practice name acronym.
 * @param practiceName - The name of the practice
 * @returns The acronym of the practice name (e.g., "HP" for "Hogwarts practice")
 */
export const generateEhrLastName = (practiceName: string): string => {
  return convertToAcronym(practiceName);
};
